import Navbar from "./Navbar";
import Footer from "./Footer";
import { useEffect, useState } from "react";
import axios from "../../api";
import { Link } from "react-router-dom";
import { ChevronDown, Menu, Star } from "lucide-react";

export default function AllProducts() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [showSidebar, setShowSidebar] = useState(false);

  // Load categories
  useEffect(() => {
   axios.get("/api/booking-categories/").then((res) => setCategories(res.data));
  }, []);

  // Load all products
  useEffect(() => {
    axios.get("/api/products/").then((res) => setProducts(res.data));
  }, []);

  // Load products by category
  const loadCategory = (slug) => {
    setSelectedCategory(slug);

    if (slug === "all") {
      axios.get("/api/products/").then((res) => setProducts(res.data));
    } else {
      axios.get(`/api/products/booking-category/${slug}/`).then((res) => setProducts(res.data));
    }

    setShowSidebar(false);
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      <Navbar />

      {/* Mobile Toggle */}
      <div className="md:hidden flex justify-between items-center px-4 py-3 bg-white shadow-sm sticky top-0 z-20">
        <h1 className="text-lg font-semibold text-gray-700">
          {selectedCategory === "all"
            ? "All Products"
            : `${(selectedCategory || "").toUpperCase()} Products`}
        </h1>

        <button
          onClick={() => setShowSidebar(!showSidebar)}
          className="flex items-center gap-1 text-indigo-600"
        >
          Categories {showSidebar ? <ChevronDown size={18} /> : <Menu size={18} />}
        </button>
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-[250px_1fr] gap-6 mt-6 px-4">

        {/* Sidebar */}
        <aside
          className={`bg-white p-4 rounded-lg shadow-md h-fit md:sticky md:top-24 z-10 
          ${showSidebar ? "block" : "hidden md:block"}`}
        >
          <h2 className="text-lg font-semibold mb-3 border-b pb-2">Categories</h2>

          <ul className="space-y-1">
            <li>
              <button
                onClick={() => loadCategory("all")}
                className={`w-full px-3 py-2 rounded-md font-medium text-sm ${
                  selectedCategory === "all"
                    ? "bg-indigo-600 text-white"
                    : "hover:bg-indigo-100"
                }`}
              >
                All
              </button>
            </li>

            {categories.map((cat) => (
              <li key={cat.id}>
                <button
                  onClick={() => loadCategory(cat.slug)}
                  className={`w-full px-3 py-2 rounded-md font-medium text-sm ${
                    selectedCategory === cat.slug
                      ? "bg-indigo-600 text-white"
                      : "hover:bg-indigo-100"
                  }`}
                >
                  {cat.name}
                </button>
              </li>
            ))}
          </ul>
        </aside>

        {/* Product Grid */}
        <main>
          <h2 className="text-xl font-semibold mb-4">
            {selectedCategory === "all"
              ? "All Products"
              : `${(selectedCategory || "").toUpperCase()} Products`}
          </h2>

          {products.length === 0 ? (
            <p className="text-lg text-gray-500">No products found.</p>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">

              {products.map((p) => (
                <div
                  key={p.id}
                  className="bg-white rounded-lg shadow-md hover:shadow-xl border transition transform hover:-translate-y-1"
                >
                  <Link to={`/product/${p.id}`}>
                    <div className="p-3">
                      <img
                        src={p.image}
                        className="w-full h-48 object-contain rounded-md bg-gray-50 p-3"
                      />
                    </div>
                  </Link>

                  <div className="px-3 pb-4">
                    <Link
                      to={`/product/${p.id}`}
                      className="text-sm font-medium text-gray-800 hover:text-indigo-600"
                    >
                      {p.title}
                    </Link>

                    {/* Ratings */}
                    <div className="flex items-center gap-1 mt-1">
                      <span className="bg-green-600 text-white px-1.5 py-0.5 rounded text-xs flex items-center gap-1">
                        {p.rating || 4.2} <Star size={12} />
                      </span>
                      <span className="text-xs text-gray-500">
                        ({p.rating_count || 1000})
                      </span>
                    </div>

                    {/* Price */}
                    <p className="text-lg font-bold mt-2 text-gray-800">
                      ₹{p.discount_price || p.price}
                    </p>
                    {p.discount_price && (
                      <p className="text-sm text-gray-500 line-through">
                        ₹{p.price}
                      </p>
                    )}

                    
                  </div>
                </div>
              ))}

            </div>
          )}
        </main>
      </div>

      <Footer />
    </div>
  );
}
